import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const PlanStatusModal = ({ isOpen, planName, status, onClose }) => {
  if (!isOpen) return null;

  const isActive = status === 'active';
  const title = isActive
    ? `Your ${planName} plan is active.`
    : `Your ${planName} plan change is scheduled.`;
  const description = isActive
    ? 'We are starting analysis from the beginning of the current month. Commits may take a few moments to appear while the initial sync completes. To analyze commits from before this month, go to Historical Analysis.'
    : 'Your current plan remains active until the next billing period.';

  return (
    <div
      className="fixed inset-0 z-[1100] flex items-center justify-center bg-slate-950/60 p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-status-modal-title"
    >
      <div className="w-full max-w-lg rounded-[1.5rem] border border-slate-200 bg-white p-6 shadow-2xl dark:border-slate-700 dark:bg-slate-900 sm:p-8">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-emerald-100 text-emerald-600 dark:bg-emerald-500/15 dark:text-emerald-300">
          <svg
            viewBox="0 0 20 20"
            className="h-7 w-7"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="m4.5 10.5 3.25 3.25L15.5 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2
          id="plan-status-modal-title"
          className="mt-5 text-2xl font-black tracking-tight text-slate-950 dark:text-white"
        >
          {title}
        </h2>
        <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
          {description}
        </p>
        <div className="mt-7 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-slate-200 px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            {isActive ? 'Not now' : 'Got it'}
          </button>
          {isActive && (
            <Link
              to="/settings/historical-analysis"
              onClick={onClose}
              className="rounded-xl bg-cyan-500 px-4 py-3 text-center text-sm font-black text-white transition hover:bg-cyan-600"
            >
              Go to Historical Analysis
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

PlanStatusModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  planName: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['active', 'scheduled']).isRequired,
  onClose: PropTypes.func.isRequired
};

export default PlanStatusModal;
